import { render } from "./NewExercicioView.vue?vue&type=template&id=ebeddcda&scoped=true"
import script from "./NewExercicioView.vue?vue&type=script&lang=js"
export * from "./NewExercicioView.vue?vue&type=script&lang=js"

import "./NewExercicioView.vue?vue&type=style&index=0&id=ebeddcda&lang=scss&scoped=true"
import "./NewExercicioView.vue?vue&type=style&index=1&id=ebeddcda&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebeddcda"]])

export default __exports__